import { useState } from 'react';
import './ProductTable.css';
import { ApiProduct } from '../../types';
import { Link } from 'react-router-dom';
import { QuantityInput } from '../Form/QuantityInput';
import { useCart } from '../../state/cart';
import { useFormatting } from '../../i18n/i18n';

import { useTranslation } from '../../i18n/i18n';
import { Img } from '../Img/Img';
import { Button } from '../Form/Button';
import { Table } from '../Table/Table';
import { FlyToCartContainer } from '../FlyToCart/FlyToCart';
import { DeliveryTime } from '../product/DeliveryTime';

type ProductTableProps = {
	products: ApiProduct[];
	highlightId?: number;
};
export const ProductTable = ({ products, highlightId }: ProductTableProps): JSX.Element => {
	return (
		<Table>
			<tbody>
				{products.map((product) => (
					<ProductTableRow
						className={highlightId === product.id ? 'highlight' : undefined}
						key={product.id}
						product={product}
					/>
				))}
			</tbody>
		</Table>
	);
};

const ProductTableRow = ({ product, className }: { product: ApiProduct; className?: string }): JSX.Element => {
	const { asPrice } = useFormatting();
	const { setQuantity, currentCount } = useCart();
	const [quantityField, setQuantityField] = useState(product.bundleSize);
	const { flyToCart } = FlyToCartContainer.useContainer();
	const t = useTranslation().product;

	const handleAddToCart = (id: number) => {
		setQuantity(id, currentCount(id) + quantityField);
		flyToCart();
	};

	const { id, displayId, name, image, unit, perma, bundleSize, price, deliveryClass } = product;

	return (
		<tr className={className}>
			<td>
				<Img src={image} width={50} height={50} alt={name} />
			</td>
			<td>
				<Link to={'/' + perma}>{name}</Link>
			</td>
			<td className="not-mobile">{displayId}</td>
			<td className="not-mobile">
				<DeliveryTime deliveryClass={deliveryClass} textLength={'short-two-lines'} />
			</td>
			<td>
				{asPrice(price)}/{unit}
			</td>
			<td className="not-mobile">
				<QuantityInput
					defaultValue={quantityField}
					onBlur={(value) => setQuantityField(value)}
					step={bundleSize}
				/>
			</td>
			<td className="not-mobile">
				<Button onClick={() => handleAddToCart(id)}>{t.buyNow}</Button>
			</td>
		</tr>
	);
};
